import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Select,
  Spin,
  notification,
} from "antd";

import React, { useState, useEffect, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import AllergensApi from "../../common/Apis/AllergensApi";
import DepartmentDropdown from "../../common/DropDowns/Department";

const EditAllergens = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const [Allergens, setAllergens] = useState();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const getAllergens = useCallback(() => {
    AllergensApi.SingleAllergensApi(id)
      .then((response) => {
        console.log(response);
        setAllergens(response.payload);
        form.setFieldsValue({
          allergensName: response?.payload?.allergensName,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);



  useEffect(() => {
    PageLoading();
    getAllergens();
  }, [getAllergens, PageLoading]);

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      allergensName: data.allergensName,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    AllergensApi.PutAllergensApi(Allergens?.id, formData)
      .then((response) => {
        console.log(response);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Updated Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/allergens");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={form}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={0}>
                <Col lg={12} md={12}>
                  <Form.Item
                    name="allergensName"
                    label="Allergens Name*"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Allergens Name",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Allergens Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default EditAllergens;
